"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AjaxContentContext = exports.AjaxContentContainer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utilityClassNames = require("@emcm-ui/utility-class-names");

var _utilityClassNames2 = _interopRequireDefault(_utilityClassNames);

var _utilityRehydratableName = require("@emcm-ui/utility-rehydratable-name");

var _utilityRehydratableName2 = _interopRequireDefault(_utilityRehydratableName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This component provides an abstracted method of providing AjaxContent with a HREF to load using React Context
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This allows the component outputting the HREF to be unaware of the AjaxContent's location it the DOM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var AjaxContentContext = _react2.default.createContext(false);

var AjaxContentContainer = function (_React$Component) {
  _inherits(AjaxContentContainer, _React$Component);

  function AjaxContentContainer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AjaxContentContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AjaxContentContainer.__proto__ || Object.getPrototypeOf(AjaxContentContainer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      href: ""
    }, _this.getClassName = (0, _utilityClassNames2.default)(AjaxContentContainer.displayName), _this.updateHref = function (href) {
      _this.setState({
        href: href
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AjaxContentContainer, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        {
          "data-rehydratable": (0, _utilityRehydratableName2.default)(AjaxContentContainer.displayName)
        },
        _react2.default.createElement(
          AjaxContentContext.Provider,
          {
            value: {
              href: this.state.href,
              updateHref: this.updateHref
            }
          },
          this.props.children
        )
      );
    }
  }]);

  return AjaxContentContainer;
}(_react2.default.Component);

AjaxContentContainer.displayName = "AjaxContentContainer";
AjaxContentContainer.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
};
exports.default = AjaxContentContainer;
exports.AjaxContentContainer = AjaxContentContainer;
exports.AjaxContentContext = AjaxContentContext;